export default "__VITE_ASSET__D1ZC1NAW__"